package music.jammers.client.shared.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.ic_close
import music.jammers.shared.event.domain.model.EventInstrument
import music.jammers.shared.event.domain.model.EventMember
import org.jetbrains.compose.resources.painterResource

@Composable
fun InstrumentImage(
    eventInstrument: EventInstrument,
    onClick: (() -> Unit)? = null,
    onDeleteClicked: (() -> Unit)? = null,
    modifier: Modifier = Modifier,
) {
    val instrument = getInstrumentByType(eventInstrument.instrument)
    val icon = instrument.icon

    val isOptional = eventInstrument.status == EventInstrument.Status.OPTIONAL

    val tintColor = if (isOptional) {
        MaterialTheme.colorScheme.primary
    } else {
        instrument.iconColor
    }

    val backgroundColor = if (isOptional) {
        optionalInstrumentColor
    } else {
        MaterialTheme.colorScheme.secondaryContainer
    }

    Box(
        modifier = Modifier
            .size(62.dp)
    ) {
        var boxModifier = modifier
            .size(54.dp)
            .clip(shape = CircleShape)
            .background(
                color = backgroundColor,
            )

        if (onClick != null) {
            boxModifier = boxModifier.clickable(onClick = onClick)
        }

        Column {
            Spacer(modifier = Modifier.size(8.dp))

            Box(
                modifier = boxModifier,
            ) {
                Icon(
                    painter = painterResource(icon),
                    tint = tintColor,
                    contentDescription = "Instrument",
                    modifier = Modifier.align(Alignment.Center),
                )
            }
        }

        if (onDeleteClicked != null) {
            Image(
                painter = painterResource(Res.drawable.ic_close),
                contentDescription = "Close",
                modifier = Modifier
                    .align(Alignment.TopEnd)
                    .clickable(onClick = onDeleteClicked)
            )
        }
    }
}

@Composable
fun MemberInstrumentImage(
    eventMember: EventMember,
    onClick: (EventMember) -> Unit,
    modifier: Modifier = Modifier,
) {
    val instrument = getInstrumentByType(eventMember.instrumentType.instrument)
    val icon = instrument.icon

    val isOptional = eventMember.defaultStatus == EventMember.Status.OPTIONAL

    val tintColor = if (isOptional) {
        MaterialTheme.colorScheme.primary
    } else {
        instrument.iconColor
    }

    val backgroundColor = if (isOptional) {
        optionalInstrumentColor
    } else {
        MaterialTheme.colorScheme.secondaryContainer
    }

    Box(
        modifier = Modifier
            .size(62.dp)
    ) {
        val boxModifier = modifier
            .size(54.dp)
            .clip(shape = CircleShape)
            .background(
                color = backgroundColor,
            ).clickable(
                onClick = {
                    onClick(eventMember)
                }
            )

        Column {
            Spacer(modifier = Modifier.size(8.dp))

            Box(
                modifier = boxModifier,
            ) {
                Icon(
                    painter = painterResource(icon),
                    tint = tintColor,
                    contentDescription = "Instrument",
                    modifier = Modifier.align(Alignment.Center),
                )
            }
        }
    }
}
